module.exports = __webpack_public_path__ + "img/bna2.cbe95107.png";